module.exports = __webpack_public_path__ + "img/no-data-grid.bc151fe.svg";